(function () {
  function getProductUrl(card) {
    if (card.dataset.productUrl) return card.dataset.productUrl;

    const overlay = card.querySelector('.card__inner > .card__link-overlay[href]');
    if (overlay) return overlay.href;

    const titleLink = card.querySelector('.card > .card__content .card__heading a[href]');
    return titleLink ? titleLink.href : null;
  }

  document.addEventListener(
    'click',
    function (event) {
      const media = event.target.closest('.product-card-wrapper .card__media');
      if (!media) return;

      if (event.target.closest('button, .quick-add, modal-opener, product-form, quick-add-bulk, quantity-popover')) {
        return;
      }

      const card = media.closest('.product-card-wrapper');
      if (!card) return;

      const url = getProductUrl(card);
      if (!url) return;

      event.preventDefault();
      window.location.assign(url);
    },
    true
  );
})();
